var messageInfo = {
  state: {
    messageInfo: [],
    todoList: [],
    messageListCount: 0,
    todoListCount: 0,
    allCount: 0
  },
  getters: {
    getMessageInfo: function getMessageInfo(state) {
      return state.messageInfo;
    },
    getTodoList: function getTodoList(state) {
      return state.todoList;
    },
    getMessageListCount: function getMessageListCount(state) {
      return state.messageListCount;
    },
    getTodoListCount: function getTodoListCount(state) {
      return state.todoListCount;
    },
    getAllCount: function getAllCount(state) {
      return state.allCount;
    }
  },
  mutations: {
    commitMessageInfo: function commitMessageInfo(state, obj) {
      state.messageInfo = obj.arr;
      state.messageListCount = obj.count;
    },
    commitGetTodoList: function commitGetTodoList(state, obj) {
      state.todoList = obj.arr;
      state.todoListCount = obj.count;
    },
    commitGetAllCount: function commitGetAllCount(state, count) {
      state.allCount = count;
    },
    commitGetMessageListCount: function commitGetMessageListCount(state, count) {
      state.messageListCount = count;
    },
    commitGetTodoListCount: function commitGetTodoListCount(state, count) {
      state.todoListCount = count;
    },
    commitListSwitch: function commitListSwitch(state, arr) {
      state.messageInfo = [];
      state.todoList = [];
      for (var key in arr) {
        if (arr[key].type == 0) {
          if (state.messageInfo.length >= 4) {
            continue;
          } else {
            state.messageInfo.push(arr[key]);
          }
        } else {
          if (state.todoList.length >= 4) {
            continue;
          } else {
            state.todoList.push(arr[key]);
          }
        }
      }
    }
  },
  actions: {
    dispatchMessageInfo: function dispatchMessageInfo(context, obj) {
      context.commit("commitMessageInfo", {
        arr: obj.data,
        count: obj.count
      });
    },
    dispatchGetTodoList: function dispatchGetTodoList(context, obj) {
      context.commit("commitGetTodoList", {
        arr: obj.data,
        count: obj.count
      });
    },
    dispatchGetAllCount: function dispatchGetAllCount(context, count) {
      context.commit("commitGetAllCount", count);
    },
    dispatchGetMessageListCount: function dispatchGetMessageListCount(context, count) {
      context.commit("commitGetMessageListCount", count);
    },
    dispatchGetTodoListCount: function dispatchGetTodoListCount(context, count) {
      context.commit("commitGetTodoListCount", count);
    },
    dispatchListSwitch: function dispatchListSwitch(context, arr) {
      context.commit("commitListSwitch", arr);
    }
  }
};
export default messageInfo;